import React from "react";
import {
  Heading,
  Image,
  Flex,
  Box,
  Text,
  Divider,
  Button,
  UnorderedList,
  ListItem,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Link,
  useMediaQuery,
} from "@chakra-ui/react";
import Section from "../../Component/Layout/Section";
import PageTitle from "../../Component/Page/PageTitle";
import { faqData } from "./meta";
import { theme } from "../../assets/style/theme";
import { responsiveValue } from "../../assets/style/defaultTheme";
import { mobileFull } from "../../util";
import LineBreakOnDesktop from "../../Component/Br/LineBreakOnDesktop";
import LineBreakOnMobile from "../../Component/Br/LineBreakOnMobile";

const { flexBoxDirection } = responsiveValue;

function Donation() {

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  
  const setionContentWith = isMobile ? '100%' : '76%';
  const buttonStyle = {
    padding: isMobile ? '12px 16px' : '24px 38px',
    height: isMobile ? '60px' : '80px',
    fontSize: isMobile ? '16px' : '24px',
  }

  return (
    <>
      <PageTitle
        type="big"
        bgPath="donation/bg.jpg"
        title="정기/일시후원"
        description="지속가능하고 건강한 사회를 만들기 위해<br />숲과나눔의 나눔의 길에 함께 해주세요."
      />
      <Section pb={1} pt={80}>
        <Heading as="h1" size={isMobile ? '2xl' : '5xl'} color="b.dgr" pb="12">
        숲과나눔의 후원회원으로 모십니다.
        </Heading>
        <Text fontSize="xl" color="b.g" fontWeight="bold" textAlign="justify">
        (재)숲과나눔은 가정, 일터, 지역사회의 환경이 숲과 같이 건강하고, 안전하며, 지속가능한 곳이어야 한다는
        우리 사회의 여망이 모여 만들어진 비영리재단입니다. 환경 분야 미래 인재 양성을 위한 장학금과 연구비 지원사업, 시민, 청년, 저개발국가 등을 대상으로 하는 환경 혁신 아이디어 지원사업을 펼치고 있습니다.
        또한 영세사업장과 소외 계층 대상의 산업보건 지원사업, 그리고 문화, 전시, 출판, 아카이브 등의 사업을 통한
        시민들의 환경 인식 향상을 위해 노력하고 있습니다.
        <br />
        <br />
        숲과나눔은 설립 이후 공공성, 투명성, 전문성, 독립성이라는 핵심가치를 확고하게 지키고 있습니다. 
        앞으로도 이런 가치와 원칙을 흔들림 없이 유지해 나가기 위해서는 후원자와 동반자가 절실하게 필요합니다.
        <br />
        <br />
        숲과나눔은 함께 했던 그리고 함께 할 모든 분들과의 인연 하나하나를 소중하게 생각합니다.
        허락하시는 후원회원 멤버십은 숲과나눔이 지향하는 가치와 사업에 대한 강력한 지지와 격려,
        동시에 동반자임을 보여주는 표상이 될 것입니다.
        소중한 후원은 모두 숲과나눔의 다양한 풀씨사업의 수혜자들에게 돌아가 아름다운 꽃을 피우고 숲을 만드는 밑거름이 될 것입니다.<br />
        감사합니다.
        </Text>
        <Box overflow="hidden" pt="16">
          <Box float="right">
            <Flex alignItems="center">
              <Text>2018년 8월<br />(재)숲과나눔 이사장</Text>
              <Image src="/images/about/sign.png" maxW="190" pl="6" />
            </Flex>
          </Box>
        </Box>
      </Section>
      <Section>
        <Box>
        <Image src="/images/donation/donation_img.png" />
        </Box>
      </Section>
      <Section pt={1} pb={1}>
        <Flex justifyContent="space-between" direction={flexBoxDirection}>
          <Box>
            <Heading size="4xl" color="b.bk" lineHeight="1.5">후원영역</Heading>            
          </Box>
          <Box w={setionContentWith}>
            <Flex alignItems="center" direction={flexBoxDirection}>
              <Heading w={mobileFull(isMobile, '25%')} size="xl" color="b.g" pt="3">인재양성사업</Heading>
              <Box w={mobileFull(isMobile, '75%')}>
                <Heading size="xl" color="b.bk" pt="3">환경·안전·보건 분야의 인재를 양성하는 장학사업과 난제 해결을 위한 연구지원 사업</Heading>
              </Box>
            </Flex>
            <Divider color="b.lg" mt="7" mb="7" borderStyle="dotted" />
            <Flex alignItems="center" direction={flexBoxDirection}>
              <Heading w={mobileFull(isMobile, '25%')} size="xl" color="b.g" pt="3">대안개발사업</Heading>
              <Box w={mobileFull(isMobile, '75%')}>
                <Heading size="xl" color="b.bk" pt="3">지속가능한 사회를 위한 시민 아이디어의 실행, 사업화, 정책화, 전국 단위 확산을 단계적 지원</Heading>                
              </Box>
            </Flex>
            <Divider color="b.lg" mt="7" mb="7" borderStyle="dotted" />            
            <Flex alignItems="center" direction={flexBoxDirection}>
              <Heading w={mobileFull(isMobile, '25%')} size="xl" color="b.g" pt="3">교육·문화·협력사업</Heading>
              <Box w={mobileFull(isMobile, '75%')}>
                <Heading size="xl" color="b.bk" pt="3">지역사회 문제의 실질적 해결 및 인식 향상을 위한 문화 사업 </Heading>                
              </Box>
            </Flex>
            <Divider color="b.lg" mt="7" mb="7" borderStyle="dotted" />            
            <Flex alignItems="center" direction={flexBoxDirection}>
              <Heading w={mobileFull(isMobile, '25%')} size="xl" color="b.g" pt="3">기타</Heading>
              <Box w={mobileFull(isMobile, '75%')}>
                <Heading size="xl" color="b.bk" pt="3">숲과나눔 일반운영기금 등</Heading>                
              </Box>
            </Flex>
            <Divider color="b.lg" mt="7" mb="7" borderStyle="dotted" />            
          </Box>
        </Flex>
        <Divider color="b.lg" pt="20" />
      </Section>
      <Section pt={80} pb={1}>
        <Flex justifyContent="space-between" direction={flexBoxDirection}>
          <Box mb={isMobile ? 4 : 0}>
            <Heading size="4xl" color="b.bk" lineHeight="1.5">후원회원<LineBreakOnDesktop />신청</Heading>            
          </Box>
          <Box w={setionContentWith}>
            <Flex alignItems="center" justifyContent={isMobile ? 'space-between' : ''}>
              <a href="https://mrmweb.hsit.co.kr/v2/default.aspx?Server=OOnCuQcBLccuWbPmV9TXcg==&action=join" target="_blank" rel="noreferrer">
                <Button size={isMobile ? 'md' : 'lg'} colorScheme="dgr" {...buttonStyle}>정기후원 하러가기</Button>
              </a>
              <a href="https://mrmweb.hsit.co.kr/v2/default.aspx?Server=OOnCuQcBLccuWbPmV9TXcg==&action=once2" target="_blank" rel="noreferrer">
                <Button ml="4" size={isMobile ? 'md' : 'lg'} colorScheme="og"  {...buttonStyle}>일시후원 하러가기</Button>
              </a>
            </Flex>
            <Divider color="b.lg" mt="7" mb="7" borderStyle="dotted" />
            <Flex direction={flexBoxDirection}> 
              <Heading w={mobileFull(isMobile, '25%')} size="2xl" color="b.g" mb={isMobile ? '6' : '0'} >무통장입금</Heading>
              <Box>
                <Heading size={isMobile ? 'xl' : '4xl'} color="b.dgr" pb="8">한국SC은행 440-20-228795 (재)숲과나눔</Heading>
                <Text fontSize="xl" color="b.g">무통장입금으로 일시후원 가능합니다.<br />무통장입금 후 후원자 안내를 위해 연락 부탁드립니다.</Text>
              </Box>
            </Flex>
            {/* <Divider color="b.lg" mt="7" mb="7" borderStyle="dotted" /> */}
            {/* <Flex>
              <Heading w="25%" size="2xl" color="b.g">전화신청</Heading>
              <Heading size="4xl" color="b.dgr" >02-6318-9000</Heading>
            </Flex>
            <Divider color="b.lg" mt="7" mb="7" borderStyle="dotted" />
            <Flex>
              <Heading w="25%" size="2xl" color="b.g">팩스발송</Heading>
              <Box>
                <Heading size="4xl" color="b.dgr" pb="2">02-6318-9100</Heading>
                <Text fontSize="xl" color="b.dgr">(약정서 작성 후 팩스 발송)</Text>
              </Box>
            </Flex>
            <Divider color="b.lg" mt="7" mb="7" borderStyle="dotted" />
            <Flex>
              <Heading w="25%" size="2xl" color="b.g">이메일 신청</Heading>
              <Box>
                <Heading size="4xl" color="b.dgr" pb="2">koreashe@koreashe.org</Heading>
                <Text fontSize="xl" color="b.dgr">(약정서 작성 후 이메일 발송)</Text>
              </Box>
            </Flex> */}
          </Box>
        </Flex>
        <Divider color="b.lg" pt="20" />
      </Section>
      <Section pt={80} pb={1}>
        <Flex justifyContent="space-between" direction={flexBoxDirection} >
          <Box>
            <Heading size="4xl" color="b.bk" lineHeight="1.5">후원<LineBreakOnDesktop />프로그램</Heading>
            <Text pt="4" textAlign="right">* 개인, 기업 무관</Text>
          </Box>
          <Box w={setionContentWith}>
            <Flex direction={flexBoxDirection}>
              <Heading w={mobileFull(isMobile, '25%')} size="2xl" color="b.g" mb={isMobile ? '4' : '0'}>풀씨</Heading>
              <Heading size={isMobile ? '2xl' : '4xl'} color="b.dgr">월 5천 원 이상~10만 원 미만 후원 </Heading>
            </Flex>
            <Divider color="b.lg" mt="7" mb="7" borderStyle="dotted" />
            <Flex direction={flexBoxDirection}>
              <Heading w={mobileFull(isMobile, '25%')} size="2xl" color="b.g" mb={isMobile ? '4' : '0'}>풀꽃</Heading>
              <Heading size={isMobile ? '2xl' : '4xl'}color="b.dgr">월 10만 원 이상 후원 </Heading>
            </Flex>
            <Divider color="b.lg" mt="7" mb="7" borderStyle="dotted" />
            <Flex direction={flexBoxDirection}>
              <Heading w={mobileFull(isMobile, '25%')} size="2xl" color="b.g" mb={isMobile ? '4' : '0'}>풀숲</Heading>
              <Box>
                <Heading size={isMobile ? '2xl' : '4xl'}color="b.dgr" lineHeight="1.4">연 1,000만 원 이상 후원<br/>유산기부자</Heading>
                <Text fontSize="lg" color= "b.g" pt="4">
                * 유산기부자에게는 법적 자문과 세제 혜택 등 별도의 전문가팀을 구성하여 지원을 드리며,<LineBreakOnDesktop/> 홈페이지에 별도 공지 및 특별 영상물 등을 제작해 드립니다.
                </Text>
              </Box>
            </Flex>
            <Divider color="b.lg" mt="7" mb="7" borderStyle="dotted" />
            <Flex direction={flexBoxDirection}>
              <Heading w={mobileFull(isMobile, '25%')} size="2xl" color="b.g" mb={isMobile ? 4 : 0}>기업사회공헌</Heading>
              <Box>
                <Flex alignItems={isMobile ? 'left' : 'center'} direction={flexBoxDirection}>
                  <Heading size={isMobile ? '2xl' : '4xl'} color="b.dgr" pr="8" mb={isMobile ? 4 : 0}>기업 파트너십 체결, 사회공헌 연결 등</Heading>
                  <Button colorScheme="dgr" size={isMobile ? 'lg' : 'md'} height="46px"><Link href="/partnership">바로가기</Link></Button>
                </Flex>
              </Box>
            </Flex>
          </Box>
        </Flex>
        <Divider color="b.lg" pt="20" />
      </Section>
      <Section pt={80} pb={80}>
        <Flex justifyContent="space-between" direction={flexBoxDirection}>
          <Heading size="4xl" color="b.bk" lineHeight="1.5" mb={isMobile ? '4' : '0'}>숲과나눔의<LineBreakOnDesktop /> 후원회원 혜택</Heading>
          <Box w={setionContentWith}>
            <UnorderedList fontSize="xl" styleType="disc" spacing="2" lineHeight="1.5">
              <ListItem fontSize="2xl" fontWeight="bold">지속가능한 사회를 위한 참여</ListItem>
              <ListItem fontSize="2xl" fontWeight="bold">후원자의 벽 이름 등재</ListItem>
              <ListItem fontSize="2xl" fontWeight="bold">재단 행사, 교육, 모임 우선 초청</ListItem>
              <ListItem fontSize="2xl" fontWeight="bold">숲과나눔 정기간행물 발송</ListItem>
              <ListItem fontSize="2xl" fontWeight="bold">기부금 영수증 발행</ListItem>
              <ListItem fontSize="2xl" fontWeight="bold">풀씨출판사 도서 할인 등</ListItem>
            </UnorderedList>
          </Box>
        </Flex>
        <Divider color="b.lg" pt="20" />
      </Section>
      <Section pt={1} pb={80}>
        <Flex justifyContent="space-between" direction={flexBoxDirection}>
          <Heading size="4xl" color="b.bk" lineHeight="1.5">후원 FAQ</Heading>
          <Box w={setionContentWith}>
            <Accordion>              
              {
                faqData.map((item:any, index:number) => (
                  <AccordionItem key={index}>
                    <AccordionButton>                      
                      <Heading size="2xl" color="b.g" flex='1' textAlign='left' pt="4" pb="0">
                        <Flex alignItems="center">
                          <Image src="/images/donation/icon_q.png" mr="6" h="40px" />
                          {item.title}
                        </Flex>
                        <Divider color="b.lg" borderStyle="dotted" mt="6" />
                      </Heading>
                      <AccordionIcon />
                    </AccordionButton>
                    <AccordionPanel pb={4}>
                    <Flex alignItems="flex-start">
                      <Image src="/images/donation/icon_a.png" mr="6" />
                      <Text fontSize="xl" color="b.g">
                        <div dangerouslySetInnerHTML={ {__html: item.content} } />
                      </Text>
                    </Flex>
                    </AccordionPanel>
                  </AccordionItem>

                ))
              }              
            </Accordion>
          </Box>
        </Flex>
        <Divider color="b.lg" pt="20" />
      </Section>
      <Section pt={1} pb={80}>
        <Flex justifyContent="space-between" direction={flexBoxDirection}>
          <Heading size="4xl" color="b.bk" lineHeight="1.5">후원문의</Heading>
          <Box w={setionContentWith}>
            <Heading size="4xl" color="b.dgr" lineHeight="1.5">
              02-6925-4635 <LineBreakOnMobile fallback="/ " />
              <a href="mailto:member@koreashe.org">member@koreashe.org</a>
            </Heading>      
          </Box>
        </Flex>
        <Divider color="b.lg" pt="20" />
      </Section>
      
    </>
  );
}

Donation.defaultProps = {
};

export default Donation;
